import React, { createContext, useContext, useEffect, useRef } from 'react';

export interface MobileTopBarAction {
  id: string;
  label: string;
  icon: React.ReactNode;
  order?: number;
  kind?: 'help';
  onSelect: (anchorEl: HTMLElement) => void;
}

type RegisterMobileTopBarAction = (action: MobileTopBarAction) => () => void;

export const MobileTopBarActionsContext = createContext<RegisterMobileTopBarAction | null>(null);

export const useMobileTopBarActions = () => useContext(MobileTopBarActionsContext);

export const useMobileTopBarAction = (action: MobileTopBarAction | null) => {
  const registerAction = useMobileTopBarActions();
  const actionRef = useRef(action);
  actionRef.current = action;

  const id = action?.id;
  const label = action?.label;
  const order = action?.order;
  const kind = action?.kind;

  useEffect(() => {
    if (!registerAction || !id || !label) return;

    return registerAction({
      id,
      label,
      order,
      kind,
      icon: actionRef.current?.icon,
      onSelect: anchorEl => actionRef.current?.onSelect(anchorEl),
    });
  }, [registerAction, id, label, order, kind]);
};
